module.exports = __webpack_public_path__ + "assets/img/left1-0b7e8829.png";